<template>
    <v-app>
        <div class="Admin">
            <v-navigation-drawer app color="dark" dark v-model="drawer" :mini-variant="miniVariant"
                                 :expand-on-hover="miniVariant" >
                <v-list>
                    <v-list-item>
                        <v-switch @change="keepDrawerOpened" v-model="isNavDrawerExpanded"
                                  style="transform:scale(0.8);"></v-switch>
                        <v-list-item-content>
                            <v-list-item-title>Expanded Dashboard</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item v-for="item in items" :key="item.title" :to="item.link" @click="item.action()">
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
            <div>
                <router-view></router-view>
            </div>
        </div>
    </v-app>
</template>

<script>
    import {CommonService, ParseAuthService} from "../services";

    export default {
        name: "Admin",
        created(){
        },
        methods: {
            empty(){},
            keepDrawerOpened() {
                this.miniVariant = !this.isNavDrawerExpanded;
                this.$store.commit('expandNav',this.isNavDrawerExpanded);
            },
            handleLogout() {
                CommonService.showLoading(true);
                ParseAuthService.logOut()
                    .then(() => {
                        CommonService.showLoading(false);
                        this.$router
                            .replace({
                                name: "Login",
                            })
                            .catch((ex) => {
                                CommonService.showLoading(false);
                                console.log(ex);
                            });
                    })
                    .catch((ex) => console.log(ex));
            }
        },
        data() {
            return {
                drawer: true,
                isNavDrawerExpanded: this.$store.state.expandedNav,
                miniVariant: !this.$store.state.expandedNav,
                items: [
                    {title: "Dashboard", icon: "mdi-view-dashboard", link: 'dashboard',action:this.empty},
                    {title: "Role", icon: "mdi-security", link: 'role', action:this.empty},
                    {title: "User", icon: "mdi-account", link: 'user', action:this.empty},
                    {title: "Logout", icon: "mdi-logout", link: '',action: this.handleLogout},
                ]
            }
        }
    };
</script>
